// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-C-oY","tabsBox":"styles_tabsBox__1-Qrj","createButton":"styles_createButton__3FNVg"};